/* eslint-disable no-restricted-syntax */
<template>
  <div class="uk-animation-fade">
    <!-- cover image: -->
    <div class="image-container">
      <div class="wrapper">
        <img src="../assets/jpg/skyline.jpg" alt />
        <div class="uk-animation-slide-left text uk-visible@m" :key="quote">
          <span>{{quote}}</span>
        </div>
      </div>
    </div>

    <!-- cards: -->
    <div class="uk-container card-container">
      <div class="uk-child-width-expand@m uk-grid-match uk-text-center" uk-grid>
        <div>
          <div class="uk-card uk-card-default uk-card-body uk-box-shadow-medium">
            <h3 class="uk-card-title">
              <span class="material-icons">favorite</span>
              <br />betrouwbaar
            </h3>
            <p class="uk-text-justify">
              Wij doen wat we beloven. Met de hoge kwaliteit van ons werk en korte
              communicatielijnen verwezenlijken wij uw wensen.
              Het geheim van ons succes is eerlijkheid.
            </p>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default uk-card-body uk-box-shadow-medium">
            <h3 class="uk-card-title">
              <span class="material-icons">school</span>
              <br />zorgvuldig
            </h3>
            <p class="uk-text-justify">
              Met de kennis en de ervaring van onze monteurs is uw installatie bij ons in de
              goede handen. Wij werken met de laatste ontwikkelingen en normen.
              Kwaliteit staat bij ons hoog in het vaandel.
            </p>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default uk-card-body uk-box-shadow-medium">
            <h3 class="uk-card-title">
              <span class="material-icons">schedule</span>
              <br />effectief
            </h3>
            <p class="uk-text-justify">
              Door korte lijnen werken wij zeer effectief en flexibel.
              Wij kunnen adequaat op elke project reageren en ons proces aanpassen
              aan de wensen van de klant.
              Bij ons telt goed gedaan meer dan goed gezegd.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- references: -->
    <div class="uk-container large background-secondary uk-box-shadow-medium reference-container">
      <h3 class="dark">onze referenties:</h3>
      <div class="inner-reference-container">
        <div uk-grid>
          <div class="uk-width-1-1 uk-width-2-3@m">
            <img src="../assets/client-logos/airport-lelystad.png" alt />
          </div>
          <div class="uk-width-1-1 uk-width-1-3@m">
            <img src="../assets/client-logos/qo.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { home } from '../text';

export default {
  data() {
    return {
      quote: '',
    };
  },
  methods: {
    changeQuote() {
      const quotes = home.quotes[this.$store.state.selectedLang];
      // eslint-disable-next-line prefer-destructuring
      this.quote = quotes[0];
      let counter = 1;

      this.quoteSwapper = setInterval(() => {
        this.quote = quotes[counter];
        counter += 1;
        if (counter === quotes.length) {
          counter = 0;
        }
      }, 10000);
    },
  },
  watch: {
    '$store.state.selectedLang': {
      handler() {
        clearInterval(this.quoteSwapper);
        this.changeQuote();
      },
    },
  },
  mounted() {
    this.changeQuote();
  },
};
</script>

<style lang="less" scoped >
@import "../assets/vars.less";

.box-shadow {
  -webkit-box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 6px 134px -5px rgba(0, 0, 0, 0.1);
}

.image-container {
  display: flex;
  justify-content: center;
  .wrapper {
    position: relative;
  }
  img {
    width: 100%;
    max-width: 100rem;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .text {
    background: rgba(104, 104, 104, 0.486);
    padding: 1rem;
    position: absolute;
    top: 3rem;
    left: 3rem;
    font-family: "Space Mono";
    font-size: 1.5rem;
    text-transform: uppercase;
    color: rgb(255, 255, 255);
    font-weight: 400;
  }
}

.card-container {
  padding: 7rem 0;
  p {
    font-size: 1.1rem;
  }
}

.reference-container {
  .inner-reference-container {
    margin: 2rem 2rem;
  }
}
</style>
